import { Col, Row } from 'antd'
import { SystemConfigureRoute } from './SystemConfigure.routes'
import './SystemConfigure.style.less'
import SystemConfigureMenu from './SystemConfigureMenu/SystemConfigureMenu'
import Header from '@/layout/components/Header'
import { SettingOutlined } from '@ant-design/icons'
import Permission from '@/components/Permission'

function SystemConfigure() {
  return (
    <Permission roles={['ADMIN']}>
      <Header
        icon={<SettingOutlined className="icon" />}
        title={'Settings'}
        background="linear-gradient(181.35deg, #5b5b5b 1.15%, rgb(91, 91, 91,0.9) 98.85%)"
      />

      <div className="system-configure-container">
        <Row gutter={30}>
          <Col span={6}>
            <SystemConfigureMenu />
          </Col>
          <Col span={18}>
            <div className="system-configure-content">
              <SystemConfigureRoute />
            </div>
          </Col>
        </Row>
      </div>
    </Permission>
  )
}

export default SystemConfigure
